import React, { useContext, memo, useState } from 'react';

import landingContext from '../../landingContext';
import { ExploreWrapper, ExploreTxt, ArrowWrap, Arrows, ExploreArrow } from './exploreMoreStyles';

const ExploreMore = () => {
	const appContext = useContext(landingContext) || {};
	const { currElem } = appContext;

	const [showExplore, setExplore] = useState(true);

	const exploreClick = () => {
		if (currElem.current && currElem.current !== null) {
			const scrollY = currElem.current.offsetHeight + currElem.current.offsetTop;
			window.scrollTo({
				top: scrollY - 60,
				behavior: 'smooth'
			});
		}
		setExplore(false);
	};

	return showExplore ? (
		<ExploreWrapper
			justify='center'
			align='center'
			$width='auto'
			$direction='column'>
			<ExploreTxt color='#fff' className='scolltxt' bottom_M='3' top_P='5' bottom_P='5' right_P='10' left_P='10'>
				Scroll down for more
			</ExploreTxt>
			<ArrowWrap onClick={exploreClick}>
				<Arrows>
					<ExploreArrow className='back-arrow' color='#9b9b9b' down />
					<ExploreArrow top_M='7' className='back-arrow' color='#9b9b9b' down />
				</Arrows>
			</ArrowWrap>
		</ExploreWrapper>
	) : null;
};

export default memo(ExploreMore);
